import { useLoginState } from 'src/app/shared/hooks/session';
import { setPxUserData } from 'src/app/shared/utils/payments';

export function useSetPxGuestUserData(): (email: string) => Promise<void> {
	const authState = useLoginState();
	return async function setPxGuestUserData(email) {
		if (authState !== 'GUEST') return;
		await setPxUserData({ email });
	};
}
